import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { generateWebsite } from '../../api/cms.api';
import { getEnvironmentVariable } from '../../utils';
import './CreateWebsite.scss';

type PromptResult = {
    promptText: string;
    viewLink: string;
    editLink: string;
};

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');

const CreateWebsite = () => {
    const { id } = useParams();
    const [ prompt, setPrompt ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState<React.ReactNode>('');
    const [ result, setResult ] = useState<PromptResult | null>(null);

    const showErrorMessage = (response: any) => {
        if (response?.message && response?.data) {
            setError(
                <>
                    {response.message}
                    {' '}
                    {Object.keys(response.data).map((key) => {
                        const link = response.data[key];

                        if (!link) {
                            return null;
                        }

                        return (
                            <a key={key} href={link} target="_blank" rel="noreferrer">link</a>
                        );
                    })}
                </>,
            );

            return;
        }

        setError('Something went wrong, please try again or contact admin.');
    };

    const handleSubmit = async () => {
        let message = prompt;
        let userText = prompt;

        if (!prompt.trim()) {
            return;
        }

        setLoading(true);
        setError('');
        setResult(null);

        const handleSuccess = (response: any) => {
            setPrompt('');

            if (response.Website) {
                setResult({
                    promptText: userText,
                    viewLink: `${platformURL}/page/${id}`,
                    editLink: `/edit-website/${id}`,
                });
                return;
            }

            setResult({
                promptText: userText,
                viewLink: response.data.show,
                editLink: response.data.edit,
            });

        };

        try {
            let response = await generateWebsite(message, id);

            setLoading(false);

            if (!response.Website) {
                setLoading(true);
                setError('');
                setResult(null);

                response = await generateWebsite(message, id);

                setLoading(false);

                if (!response.Website) {
                    showErrorMessage(response);
                    return;
                }
            }

            handleSuccess(response);
        } catch (error) {
            setLoading(false);
            showErrorMessage(error);
        }
    };

    return (
        <div className="create-website">
            <div className="create-website-bg">
                <div className="create-website-blob create-website-blob1"/>
                <div className="create-website-blob create-website-blob2"/>
            </div>

            <div className="create-website-container">
                <div className="create-website-main">
                    <div className="create-website-prompt-wrapper">
                        <input
                            className="create-website-prompt_input"
                            value={prompt}
                            placeholder="Ask anything..."
                            onChange={(e) => setPrompt(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    void handleSubmit();
                                }
                            }}
                        />

                        <button
                            className="create-website-prompt_btn"
                            disabled={loading || !prompt.trim()}
                            onClick={() => void handleSubmit()}
                        >
                            <svg fill="#ffffff" height="18" width="18" viewBox="0 0 51.983 51.983">
                                <path
                                    d="M45.257,22.339l-18.5-22c-0.381-0.452-1.15-0.452-1.531,0l-18.5,22c-0.25,0.297-0.305,0.713-0.141,1.066c0.164,0.352,0.518,0.578,0.906,0.578h8.486l4.199,25.196c0.262,1.572,1.716,2.804,3.312,2.804h5.005c1.595,0,3.05-1.231,3.313-2.804l4.198-25.196h8.487c0.389,0,0.742-0.226,0.906-0.578C45.562,23.052,45.507,22.636,45.257,22.339z"/>
                            </svg>
                        </button>

                        {/*<button*/}
                        {/*    type="button"*/}
                        {/*    className="create-website-upload-btn"*/}
                        {/*    onClick={handleUploadClick}*/}
                        {/*>*/}
                        {/*    {selectedFile ? selectedFile.name : 'Upload'}*/}
                        {/*</button>*/}

                        {/*<input*/}
                        {/*    ref={fileInputRef}*/}
                        {/*    type="file"*/}
                        {/*    accept=".csv,.json"*/}
                        {/*    hidden*/}
                        {/*    onChange={(e) => {*/}
                        {/*        setSelectedFile(e.target.files?.[0] || null);*/}
                        {/*    }}*/}
                        {/*/>*/}
                    </div>

                    {loading && (
                        <div className="create-website-loader show">
                            <div className="create-website-dots">
                                <span/>
                                <span/>
                                <span/>
                            </div>
                        </div>
                    )}

                    {error && (
                        <div className="create-website-error-message show">
                            <span className="paxdi-error-icon">⚠</span>
                            <span>{error}</span>
                        </div>
                    )}

                    {result && (
                        <div className="paxdi-result-card show">
                            <div className="paxdi-result-card-content">
                                <div className="paxdi-result-card-label">Generated prompt</div>
                                <div className="paxdi-result-card-text">{result.promptText}</div>
                            </div>

                            <div className="paxdi-result-card-actions">
                                <a
                                    href={result.viewLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="paxdi-result-card-btn paxdi-result-card-btn-primary"
                                >
                                    View website
                                </a>

                                <a
                                    href={result.editLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="paxdi-result-card-btn paxdi-result-card-btn-secondary"
                                >
                                    Edit website
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CreateWebsite;
